import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors, quartileColorStyles } from '../../styles';
import { Quartile } from '../../types/graphs';
import { CircleProps } from '../../types/svg';
import vehicleLight from '../../assets/images/vehicle-photo-light.svg';

export interface VehicleDotProps extends CircleProps {
  avatarUrl?: string;
  className?: string;
  muted?: boolean;
  quartile?: Quartile;
}

class VehicleDot extends React.Component<VehicleDotProps, any> {
  static defaultProps: VehicleDotProps = {
    avatarUrl: vehicleLight,
    cx: 0,
    cy: 0,
    r: 10,
    quartile: 2,
    muted: false,
  };

  public render() {
    const { cx, cy, r, quartile, className, muted } = this.props;
    const avatarUrl = this.props.avatarUrl || vehicleLight;
    const holeRadius = r * 0.875;
    const photoRadius = r * 0.775;
    const photoDiameter = photoRadius * 2;
    const randomNumber = Date.now() + Math.floor(Math.random() * 9999 + 1000);
    const uniqueId = `avatar${randomNumber}`;

    return (
      <g className={`${className} ${muted ? 'muted' : ''}`}>
        <defs>
          <filter id="grayscale">
            <feColorMatrix type="saturate" values="0" />
          </filter>

          <pattern
            id={uniqueId}
            x="0%"
            y="0%"
            height="100%"
            width="100%"
            viewBox={`0 0 ${photoDiameter} ${photoDiameter}`}
          >
            <image
              x="0%"
              y="0%"
              width={photoDiameter}
              height={photoDiameter}
              xlinkHref={avatarUrl}
            />
          </pattern>
        </defs>

        <circle className={`ring quartile-${quartile}`} {...{ cx, cy, r }} />
        <circle className="hole" {...{ cx, cy, r: holeRadius }} />
        <circle
          className="vehicle-photo"
          {...{ cx, cy, r: photoRadius }}
          fill={`url(#${uniqueId})`}
        />
      </g>
    );
  }
}

const StyledVehicleDot = styled(VehicleDot)`
  ${quartileColorStyles('fill')};

  &.muted:not(.focused) .ring {
    fill: ${colors.grey100};
  }

  &.muted:not(.focused) .vehicle-photo {
    filter: url('#grayscale');
  }

  .hole {
    fill: white;
  }
`;

export default StyledVehicleDot;
